export * from "-!../../../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./breadcrumb.vue?vue&type=template&id=d79b5e72&"


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/_source/breadcrumb.vue?vue&type=template&id=d79b5e72&
// module id = 503
// module chunks = 30